import React from 'react';

const ThemeContext = React.createContext({
  themeContext: '',
  nativeRouteName: '',
  findingNearbyCompanion: false,
  setFindingNearbyCompanion: () => {},
});

export default ThemeContext;
